import React, { Component } from 'react'
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import Header from './Header'




class Faq extends Component {

        state={
            collapseID:'',
            addClass:'faqQuestionActive',
            removeClass:'faqQuestionPassive'
        };

        clickBTN = (collapseID,e) => {
    
            this.setState(prevState => ({
                collapseID: prevState.collapseID !== collapseID ? collapseID : ""
              }));
            console.log(collapseID);
        }
    render() {
        return (
            <div className="mainContainer">
            <Header/>
            <div className="faqContainer">
                <div className="faqHeader">
                    
                    <h1>SIKÇA SORULAN SORULAR</h1>
                </div>
                <Accordion>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="0" className={`faqQuestion ${this.state.collapseID==='0' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("0")}>
                            Kassa nedir?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                        Kassa, ister arkadaşlarınızla, ister bireysel tüm gelir ve giderlerinizi özel sohbet (chat) gruplarınızda takip edebildiğiniz bir finans takip uygulamasıdır. Ayrıca Kassa’nın cüzdan özelliği ile Kassa’nıza para yükleyebilir, bu parayı <span className="highlight">7/24</span> ve <span className="highlight">ücretsiz</span> bir şekilde arkadaşlarınıza gönderebilirsiniz. ^____^ 
                                        </p>
                                    </div>
                                    
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="1" className={`faqQuestion ${this.state.collapseID==='1' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("1")}>
                        Kassa nasıl çalışır?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                        Önce kendinize bir sohbet (chat) grubu oluşturursunuz, sonra telefon rehberinizden arkadaşlarınızı davet edersiniz. Böylece gruptaki arkadaşlarınızla aynı anda hem sohbet edebilir, hem de yaptığınız ortak harcamaları takip edebilirsiniz. Kassa sizi yormaz, kimin kime ne kadar borcu var söyler!  
                                        </p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="2" className={`faqQuestion ${this.state.collapseID==='2' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("2")}>
                    Kassa ücretli mi?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="2">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                            Kassa'ya üye olmak ücretsizdir.
                                        </p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="3" className={`faqQuestion ${this.state.collapseID==='3' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("3")}>
                    Kassa’da grup oluşturmak nedir?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="3">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                        Günlük hayatta kullandığınız sohbet (chat) uygulamaları gibi düşünün. 
Sohbet (chat) grubu oluşturup, rehberinizden arkadaşlarınızı davet ediyorsunuz ve bu kişiler dışında kimse bu konuşmaları göremiyor. Diğer sohbet (chat) uygulamaların yanında ekstra özellik olarak bir de harcama ekleyebildiğinizi düşünün. 
                                        </p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="4" className={`faqQuestion ${this.state.collapseID==='4' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("4")}>
                    Kassa’yı nerelerde kullanabilirim?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="4">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                        Kullanım örnekleri: <br/><br/>

<span className="quote">Ev arkadaşınızla “Beşiktaş Ev” diye bir grup açıp ev harcamalarınızı takip edebilirsiniz.</span><br/>
<span className="quote">İş arkadaşınızla “Mor Butik” diye bir grup açıp iş harcamalarınızı takip edebilirsiniz.</span><br/>
<span className="quote">Arkadaşlarınızla “Jazz Festivali” diye bir grup açıp etkinlik harcamalarınızı takip edebilirsiniz.</span><br/>
<span className="quote">Arkadaşlarınızla “Karadeniz Turu” diye bir grup açıp tatil harcamalarınızı takip edebilirsiniz.</span><br/><br/>

Bu liste böyle sonsuza doğru gider… ^^

                                        </p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="5" className={`faqQuestion ${this.state.collapseID==='5' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("5")}>
                    Cüzdan nedir?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="5">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                        Kassa içerisinde oluşturacağınız cüzdan bir e-para cüzdanıdır. İçerisine para yükleyebilir, bu parayı istediğiniz Kassa’lı arkadaşınıza <span className="highlight">7/24</span> ve <span className="highlight">ücretsiz</span> gönderebilirsiniz. Bu parayı istediğiniz zaman kendi banka hesabınıza geri alabilir ve/veya ATM’den çekebilirsiniz.
                                        </p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="6" className={`faqQuestion ${this.state.collapseID==='6' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("6")}>
                    Cüzdan ücretli mi?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="6">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                        Banka kartlarıyla yapılan yüklemelerde Bankalararası Kart Merkezi (BKM) tarafından tahsil edilen %0.6’lık komisyon bulunmaktadır. Bu komisyonu bize değil işlem yaptığınız karta ait bankaya gitmektedir.<br/>Konuyu ilgili linkten inceleyebilirsiniz. <a href="https://bkm.com.tr/faydali-bilgiler/komisyon-ve-ucretler/bankalararasi-takas-komisyonlari/" target="_blank">https://bkm.com.tr/faydali-bilgiler/komisyon-ve-ucretler/bankalararasi-takas-komisyonlari/</a>

                                        <br/><br/>Bunun haricinde banka hesaplarından para yüklemek, diğer cüzdanlara para göndermek, cüzdanınızdan bankanıza göndermek, fatura ödemek gibi tüm işlemler ücretsizdir.
                                        </p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="7" className={`faqQuestion ${this.state.collapseID==='7' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("7")}>
                    Cüzdanı nerelerde kullanabilirim?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="7">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                        Örnek 1:
Kassa’da ev arkadaşlarınızla grubunuz var. Eve alınanların hesabını tutuyorsunuz ve ay sonu evdeki bir arkadaşınıza 100 TL borcunuz çıktı. Kassa’da oluşturduğunuz cüzdanınızdan tek tuşla, 7/24 ve ücretsiz bir şekilde arkadaşınıza borcunuzu ödeyebilirsiniz.<br/><br/>

Örnek 2: 
Arkadaşınıza para mı göndermek istediniz? Cüzdanınıza giriş yapıp “Para Gönder” butonuna tıklayıp rehberinizden göndereceğiniz kişiyi seçin ve paranızı anında gönderin. Yine 7/24 ve ücretsiz olarak tabi ki. ^^
                                        </p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="8" className={`faqQuestion ${this.state.collapseID==='8' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("8")}>
                    Nasıl cüzdan açabilirim?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="8">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                        Kassa’ya girdikten sonra alt menüde bulunan “Durum” ekranına geçin. Ekranın üst bölümünde “Cüzdan Aç” butonunu göreceksiniz.
                                        </p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="9" className={`faqQuestion ${this.state.collapseID==='9' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("9")}>
                            Cüzdana nasıl para yüklerim?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="9">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            <span className="highlight">A. Bankanızdan Havale/EFT işlemi ile: </span>Kendi bankanızın internet/cep şubesine girip “Para Transferleri” adımı ile Kassa’ya para yükleyebilirsiniz. <span className="quote">(Bu transfer esnasında sizden alınacak para transfer ücreti bankanız tarafından alınmaktadır. Elimizde olsa onu da ücretsiz yaparız.)</span><br/><br/>
                                            <span className="highlight">B. Banka (Debit) Kartından: </span>Banka kartınızı Kassa'ya tanımlayarak tek tuşla Kassa'nıza para yükleyebilirsiniz.<br/><br/>
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="10" className={`faqQuestion ${this.state.collapseID==='10' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("10")}>
                        Güvenli mi?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="10">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            Kassa, Türkiye Cumhuriyeti yasalarına ve Bankacılık Denetleme ve Düzenleme Kurulu (BDDK) kurallarına uygun bir şekilde hareket eder. Bu kapsamda cüzdan ve e-para hizmetleriyle ilgili tüm altyapıyı <span className="highlight"> QNB Finansbank</span>’tan alır. Ve Kassa’da oluşturduğunuz cüzdana yüklediğiniz tüm para <span className="highlight">QNB Finansbank</span>’taki havuz hesapta saklanır.<br/><br/>

Yani diyeceğimiz o ki; Paranız %100 güvendedir. ^^
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="11" className={`faqQuestion ${this.state.collapseID==='11' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("11")}>
                        Kassa bir bankanın uygulaması mıdır?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="11">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            Hayır. Kassa %100 yerli yatırım sermayesi ile kurulmuş bağımsız bir girişimdir. Bir bankanın ya da kurumun sahibi olduğu bir girişim/şirket değildir. 

Ancak Kassa, yasalara uygunluk ve paranızın güvenliği sebebiyle lisans sahibi bir şirket ile anlaşmak durumunda olduğu için, bu bağlamda hem vizyon, hem teknoloji olarak uyuştuğumuz <span className="highlight">QNB Finansbank</span>’ı seçmiştir. Cüzdan hizmetleri ve para transferleri ile ilgili tüm altyapı hizmetini <span className="highlight">QNB Finansbank</span>’tan almaktadır.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="12" className={`faqQuestion ${this.state.collapseID==='12' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("12")}>
                        Her banka kullanıcısı kullanabilir mi?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="12">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                                Kassa’yı tüm banka kullanıcıları kullanabilir.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="13" className={`faqQuestion ${this.state.collapseID==='13' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("13")}>
                        Cüzdana yüklediğim paramı nasıl geri alırım?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="13">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            Cüzdanınızdaki paranızı dilediğiniz zaman kendi banka hesabınıza geri alabilir ve/veya en yakın <span className="highlight">QNB Finansbank</span> ATM’sinden nakit olarak çekebilirsiniz.<br/><br/>
                                            <span className="highlight">Not:</span> Cüzdanınızdaki parayı sadece kendi banka hesabınıza geri alabilirsiniz. Başkasının banka hesabına gönderemezsiniz.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="14" className={`faqQuestion ${this.state.collapseID==='14' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("14")}>
                        Paramı hangi ATM’lerden çekebilirim?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="14">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            Paranızı size en yakın <span className="highlight">QNB Finansbank</span> ATM’sinden çekebilirsiniz.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="15" className={`faqQuestion ${this.state.collapseID==='15' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("15")}>
                        Cüzdandaki limitler ne kadar?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="15">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            Bununla ilgili detaylı bilgiyi Limitler sayfamızdan inceleyebilirsiniz. <a href="http://www.kassa.co/limitler.html" target="_blank">www.kassa.co/limitler</a>
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="16" className={`faqQuestion ${this.state.collapseID==='16' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("16")}>
                        Aktiviteler ekranı ne işe yarar?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="16">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            Aktiviteler ekranında dönem içerisinde yaptığınız tüm finansal işlemleri takip edebilirsiniz. Üst bölümde yer alan menüden "Günlük" sekmesini seçerseniz tüm işlemlerinizi, "Cüzdan" sekmesini seçerseniz cüzdan üzerinden yaptığınız işlemleri görebilirsiniz. Bu ekran üzerinde gördüğünüz tüm kayıtları düzenleyebilir ve/veya yeni kayıtlar ekleyebilirsiniz.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="17" className={`faqQuestion ${this.state.collapseID==='17' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("17")}>
                        Durum ekranı ne işe yarar?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="17">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            Durum ekranı sizin tüm finansal operasyonunuzu görüntüleyebildiğiniz ve yönetebildiğiniz ekrandır. Burada Kassa'daki gruplarınız içerisindeki tüm işlemlerin özetlerini, grafik detaylarını ve kişilere olan borç ve alacaklarınızı görüntüleyebilirsiniz. Aynı zamanda bu ekran üzerinden cüzdan açabilir veya açık olan cüzdanınıza giriş yapıp cüzdan işlemlerinizi gerçekleştirebilirsiniz.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="18" className={`faqQuestion ${this.state.collapseID==='18' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("18")}>
                        Gruplar ekranı ne işe yarar?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="18">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            Gruplar ekranından Kassa içerisinde açtığınız tüm sohbet (chat) gruplarını görüntüleyebilir ve/veya yeni bir sohbet (chat) grubu açabilirsiniz. Bu ekranın sağ üst köşesinde yer alan Direkt Mesaj (DM) butonu ile istediğiniz bir arkadaşınıza özel olarak mesaj atabilirsiniz.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="19" className={`faqQuestion ${this.state.collapseID==='19' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("19")}>
                        Profil ekranı ne işe yarar?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="19">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            Profil ekranı, Kassa'yı kullanırken ihtiyacınız olan tüm ayarları yapabildiğiniz bölümdür. Buradan profil bilgilerinizi düzenleyebilir, Kassa'yı kullanım özelliklerini belirleyebilirsiniz. Aynı zamanda Kassa'ya ait hukuksal, genel ve diğer tüm bilgilendirmeler de bu bölümdedir. Kassa'ya ulaşmak, yardım talep etmek ya da Kassa hesabınızı kapamak için de yine bu ekrandaki menüleri kullanabilirsiniz.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="20" className={`faqQuestion ${this.state.collapseID==='20' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("20")}>
                        Artı (+) butonu ne işe yarar?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="20">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            Artı (+) butonu birçok işleme daha hızlı ve kolay ulaşmayı sağlar. Bu butonla birlikte grup oluşturulabilir, harcama ekleyebilir ve/veya cüzdanınıza giriş yaparak  arkadaşlarınıza 7/24 ve ücretsiz para transferi yapılabilirsiniz.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
            </div>
        )
    }
}

export default Faq